import styled from "styled-components";
import logoBig from "../../resources/images/kvalifika-logo.svg";

export const StyledLogoContainer = styled.div`
  width: 152px;
  height: 45px;
  background-image: url(${logoBig});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 450px) {
    width: 128px;
  }
`;
